import { SidebarRow } from '@widgets';
import { Text } from '@shared/widgets';

interface Props {
  label: string;
  currentAmount: number;
  limitAmount: number;
  currentNumber: number;
  limitNumber: number;
  symbol?: string;
}

export const LimitRow = (props: Props) => {
  return (
    <div className='mb-5'>
      <Text>{props.label}</Text>
      <SidebarRow
        className='mt-2 !mb-0'
        leftRowText='Used amount'
        rightRowText={props.symbol ? props.symbol + props.currentAmount + '/' + props.symbol + props.limitAmount : undefined}
      />
      <SidebarRow className='mt-2 !mb-0' leftRowText='Used txn number' rightRowText={props.currentNumber + '/' + props.limitNumber} />
    </div>
  );
};
